import * as d3 from "d3";
import {
    addGridlines,
    contextMenu,
    createAxis,
    createTooltip,
    generateDownloadData,
    inrFormatter,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam, checkbox, gridflag) {
    // set the dimensions and margins of the graph
    /*        var margin =chart.margin,
        width = chart.width - margin.left - margin.right,
        height = chart.height - margin.top - margin.bottom;*/
    var margin = {top: 40, right: 300, bottom: 120, left: 50},
        width = 1300 - margin.left - margin.right,
        height = 500 - margin.top - margin.bottom;

    // console.log("decl", chart, divId, vizName, filterParam)
// append the svg object to the body of the page
    var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");

//Read the data
//     var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // axios.post(url, filterParam).then(res => {

        // axios({ url: '/json/country_gdp_le_pop.json', baseURL: '', method: 'GET' }).then(res => {
//        d3.json("country_gdp_le_pop.json",  function(data) {
        let data = resData

        // ---------------------------//
        //       AXIS  AND SCALE      //
        // ---------------------------//
        console.log("Data", data, d3.max(data, function (d) {
            return d.metric2
        }))
        // var dataValue=data.map((d) => {
        //     return d[chart.x1DataFieldName]
        // }).sort(d3.ascending);
        // var range = [width,0]
        // Add X axis
        var x = createAxis(chart.x1D3ScaleType).domain(data.map((d) => {
            return d[chart.x1DataFieldName]
        }).sort(d3.ascending)).range([width,0]);
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x))
            .selectAll("text")
            .style("text-anchor", "end") // Optional: adjust the text anchor
            .attr("dx", "-.8em") // Optional: move the text a bit to the left
            .attr("dy", ".15em") // Optional: move the text a bit down
            .attr("transform", "rotate(-45)");

        // Add X axis label:
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("x", width)
            .attr("y", height + 50)
            .text(chart.x1AxisDisplayName);

        // var minValue=d3.min(data,d=>{return d.metric1});
        // var maxValue=d3.max(data, d => {return d.metric1})
        var value1=[d3.max(data, d => {return d.metric1}),d3.min(data,d=>{return d.metric1})];
        var range1 =[0,height]
        // Add Y axis
        var y = createAxis(chart.y1D3ScaleType).domain(value1).range(range1);
        if (gridflag === true) {
            addGridlines(svg, x, y, chart);
        }

        svg.append("g")
            .call(d3.axisLeft(y));

        // Add Y axis label:
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("x", 0)
            .attr("y", -20)
            .text(chart.y1AxisDisplayName)
            .attr("text-anchor", "start")

        // Add a scale for bubble size
        var z = d3.scaleSqrt()
            .domain(d3.extent(data, d => {
                return d.metric3
            })) //find min and max population value
            .range([2, 30]);

        // Add a scale for bubble color
        let dim1_names = [...new Set(data.map(obj => obj.dim1_name))]
        var myColor = d3.scaleOrdinal()
            .domain(dim1_names)
            .range(d3.schemeSet2);


        // ---------------------------//
        //      TOOLTIP               //
        // ---------------------------//

        const tooltip = createTooltip(divId);

        // -1- Create a tooltip div that is hidden by default:
        // var tooltip = d3.select(divId)
        //     .append("div")
        //     .style("opacity", 0)
        //     .attr("class", "tooltip")
        //     .style("background-color", "black")
        //     .style("border-radius", "5px")
        //     .style("padding", "10px")
        //     .style("color", "white")
        //
        // // -2- Create 3 functions to show / update (when mouse move but stay on same circle) / hide the tooltip
        // var showTooltip = function (d) {
        //     tooltip
        //         .transition()
        //         .duration(200)
        //     tooltip
        //         .style("opacity", 1)
        //         .html(chart.x2AxisDisplayName + ": " + d.dim1_name + "<br>" +
        //             chart.x2MetricTooltip + ": " + d.dim2_name + "<br>" +
        //             chart.x1MetricTooltip + ": " + inrFormatter(d.metric1) + "<br>" +
        //             chart.y1MetricTooltip + ": " + inrFormatter(d.metric2) + "<br>" +
        //             chart.y2MetricTooltip + ": " + inrFormatter(d.metric3) + "<br>"
        //         )
        //         .style("left", (d3.event.layerX) + "px")
        //         .style("top", (d3.event.layerY) + "px")
        // }
        // var moveTooltip = function () {
        //     tooltip
        //         .style("left", (d3.event.layerX) + "px")
        //         .style("top", (d3.event.layerY) + "px")
        // }
        // var hideTooltip = function () {
        //     tooltip
        //         .transition()
        //         .duration(200)
        //         .style("opacity", 0)
        // }


        // ---------------------------//
        //       HIGHLIGHT GROUP      //
        // ---------------------------//

        // What to do when one group is hovered
        var highlight = function (d) {
            // reduce opacity of all groups
            d3.selectAll(".bubbles").style("opacity", .05)
            // expect the one that is hovered
            d3.selectAll("." + d).style("opacity", 0.5)
        }

        // And when it is not hovered anymore
        var noHighlight = function () {
            d3.selectAll(".bubbles").style("opacity", 0.5)
        }


        // ---------------------------//
        //       CIRCLES              //
        // ---------------------------//

        // Add dots
        svg.append('g')
            .selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("class", function (d) {
                return "bubbles " + d.dim1_name
            })
            .attr("cx", function (d) {
                return x(d[chart.x1DataFieldName]);
            })
            .attr("cy", function (d) {
                return y(d.metric1);
            })
            .attr("r", function (d) {
                return z(d.metric3);
            })
            // .attr("r", 7  )
            .style("fill", function (d) {
                return myColor(d.dim1_name);
            })
            .attr('transform', 'translate(' + x.bandwidth()/2 + ', 0)')
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x2AxisDisplayName + ": " + d.dim1_name + "<br>" +
                        chart.x2MetricTooltip + ": " + d.dim2_name + "<br>" +
                        chart.x1MetricTooltip + ": " + inrFormatter(d.metric1) + "<br>" +
                        chart.y1MetricTooltip + ": " + inrFormatter(d.metric2) + "<br>" +
                        chart.y2MetricTooltip + ": " + inrFormatter(d.metric3) + "<br>"
                });
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(d) {
                console.log(d)
                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [d.dim1_name], // e.g., "metric1"
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]:[d.dim2_name]
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                d3.event.preventDefault();
            })


        // ---------------------------//
        //       LEGEND              //
        // ---------------------------//

        // Add legend: circles
        // var valuesToShow = [10000000, 100000000, 1000000000]
        var valuesToShow = [d3.min(data, function (d) {
            return d.metric3
        }),
            // d3.median(data,function(d){return d.metric3}),
            d3.max(data, function (d) {
                return d.metric3
            })]
        var xCircle = width + margin.left + margin.right - 240
        var xLabel = width + margin.left + margin.right - 180
        svg
            .selectAll("legend")
            .data(valuesToShow)
            .enter()
            .append("circle")
            .attr("cx", xCircle)
            .attr("cy", function (d) {
                return height - 100 - z(d)
            })
            .attr("r", function (d) {
                return z(d)
            })
            .style("fill", "none")
            .attr("stroke", "black")

        // Add legend: segments
        svg
            .selectAll("legend")
            .data(valuesToShow)
            .enter()
            .append("line")
            .attr('x1', function (d) {
                return xCircle + z(d)
            })
            .attr('x2', xLabel)
            .attr('y1', function (d) {
                return height - 100 - z(d)
            })
            .attr('y2', function (d) {
                return height - 100 - z(d)
            })
            .attr('stroke', 'black')
            .style('stroke-dasharray', ('2,2'))

        // Add legend: labels
        svg
            .selectAll("legend")
            .data(valuesToShow)
            .enter()
            .append("text")
            .attr('x', xLabel)
            .attr('y', function (d) {
                return height - 100 - z(d)
            })
            .text(function (d) {
                return inrFormatter(d)
            })
            .style("font-size", 10)
            .attr('alignment-baseline', 'middle')

        // Legend title
        svg.append("text")
            .attr('x', xCircle + 10)
            .attr("y", height - 100 + 30)
            .text(chart.y2AxisDisplayName)
            .attr("text-anchor", "middle")

        // Add one dot in the legend for each name.
        var size = 30
        var allgroups = dim1_names
        svg.selectAll("myrect")
            .data(allgroups)
            .enter()
            .append("circle")
            .attr("cx", xCircle)
            .attr("cy", function (d, i) {
                return 10 + i * (size + 5)
            }) // 100 is where the first dot appears. 25 is the distance between dots
            .attr("r", 7)
            .style("fill", function (d) {
                return myColor(d)
            })
            .style("opacity", 0.5)
            .on("mouseover", highlight)
            .on("mouseleave", noHighlight)

        // Add labels beside legend dots
        svg.selectAll("mylabels")
            .data(allgroups)
            .enter()
            .append("text")
            .attr("x", xCircle + size * .8)
            .attr("y", function (d, i) {
                return i * (size + 5) + (size / 2)
            }) // 100 is where the first dot appears. 25 is the distance between dots
            .style("fill", function (d) {
                return myColor(d)
            })
            .text(function (d) {
                return d
            })
            .attr("text-anchor", "left")
            .style("alignment-baseline", "middle")
            .on("mouseover", highlight)
            .on("mouseleave", noHighlight)
    // })

}
